/****Clear Cart on First Load***/
$('.pkg_price ,.pkg_save_ammount ,.atc_price').show();
if (sessionStorage.getItem("bundleToken") != null) {
  var token=sessionStorage.getItem("bundleToken");
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    data: {
      token: token
    },
    dataType: 'json',
    success: function(response) {
      sessionStorage.removeItem(token);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.querySelector("#cart-icon-bubble .cart-count-bubble")?.remove();
    }
  });
}

function returnElement(element){
  return document.querySelector(element);
}

function returnElements(element){
  return document.querySelectorAll(element);
}

/****Page Functionality Start***/

/******START: GIFT PRODUCT FUNCTIONALITY*****/
const gift_products = document.querySelectorAll(".gift-imges .variantImage");
if(gift_products.length > 0){
  gift_products.forEach(function(e){
    e.addEventListener("click",function(){
      this.closest(".gift-imges").querySelector(".variantImage.active")?.classList.remove("active");
      this.classList.add("active");
    })
  })
}
/*****END: GIFT PRODUCT FUNCTIONALITY*****/

const tabTriggers = document.querySelectorAll("button.tablinks");

if(tabTriggers.length > 0){
  tabTriggers.forEach(function(element){
    element.addEventListener("click",function(){
      const value = this.getAttribute('data-collection-handle');
      const tabs = returnElements(".tabcontent");
      tabs.forEach(function(e){e.setAttribute('hidden','true')});
      returnElement('.tabcontent[collection-handle="'+value+'"]').removeAttribute('hidden');
      tabTriggers.forEach(function(e){e.classList.remove('active')});
      this.classList.add('active');

      /***Find active product and show options of that product**/

      const activeProduct = returnElement(".tabcontent:not([hidden]) .tab_prod_container.tab_prod_container_active");
      const activeId = activeProduct.getAttribute('data-id');
      returnElement(".product_settings:not([hidden])").setAttribute("hidden",true);
      returnElement(".product_settings[data-product-id='"+activeId+"']").removeAttribute("hidden");
      
      /**Update Rooster Product**/
      activateRooster();
      
      /**Activate Button and Selling Plan**/
      getCurrentVariant();
    });
  })
}

/****Variant availability Checking***/
function convertToShopifyPrice(price) {
  // Convert price to a number
  const numericPrice = parseFloat(price);

  // Check if the price is a valid number
  if (isNaN(numericPrice)) {
    return "Invalid price";
  }

  // Format the price using toLocaleString()
  const formattedPrice = numericPrice.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });

  return formattedPrice;
}
function getCurrentVariant(){
  const variantTitle = findVariant();
  const variantInput = findVariantInput(variantTitle);
  if(variantInput.classList.contains("not-available")){
    cartTextChange("Sold Out",true);
  }
  else{
    cartTextChange("Subscribe Now",false);
  }
  const variantCurrentId = variantInput.value.split('/').pop(); 
  const variantPriceInput = variantInput.closest('.product-setting-box').querySelector(".variantPrice[variant-id='"+variantCurrentId+"']");
  const variantPrice = Number(variantPriceInput.value);
  const variantPrice2 = Number(variantPriceInput.value);
  let variantDPrice = Number(variantPriceInput.getAttribute('variant-delivery-price'));
  const priceDifference = variantPrice - variantDPrice; 

  /***Find Case Value***/

  const caseElement = returnElement(".case_selection_box:not([hidden]) .single_case.active");
  if(caseElement){
    variantDPrice += Number(caseElement.getAttribute('data-price'));
  }
   /* const roosterElement = returnElement('.Extra_rooster:not([hidden]) .freeRooster.active .roster-input[value*="'+variantTitle+'"]');
    if(roosterElement){
      variantDPrice += Number(roosterElement.getAttribute("variant-price"));
    }*/
  setTimeout(function(){
  /**Rooster founding Function**/
    const roosterOptions = returnElements(".rooster_options:not([hidden]) .rooster_selection");
    let roosterValue = "";
    if(roosterOptions.length > 0){
      roosterOptions.forEach(function(e,index){
         roosterValue = roosterValue + e.querySelector("input:checked")?.value.replace(' ','-').toLowerCase();
        if((index+1) < roosterOptions.length){
          roosterValue = roosterValue + '-';
        }
      })
    }
  
  const foundedRoosterElement = document.querySelector(".freeRooster.active .roster-input[value*='"+roosterValue+"']");
  if(!caseElement){
  if(foundedRoosterElement){
    variantDPrice += Number(foundedRoosterElement.getAttribute("variant-price"));
  }}
  /***Find Rooster Value***/
const pckgPrice = returnElements(".selling_plan_box .pkg_price");
pckgPrice.forEach(function(e){
  const discountedPrice = variantPrice2 * 0.75;  // Aplica un 25% de descuento
  e.innerText = convertToShopifyPrice(discountedPrice); // Muestra el precio con descuento
});

const saveEle = returnElements(".selling_plan_box .pkg_save_ammount");
saveEle.forEach(function(e){
  const priceDifference = variantPrice2 - (variantPrice2 * 0.75); // Diferencia de precio con descuento
  e.innerText = "Save " + convertToShopifyPrice(priceDifference); // Muestra el ahorro
});

returnElement('button.atc_btn .atc_price').innerText = convertToShopifyPrice(variantDPrice);
}, 100);

}
function cartTextChange(buttonText,buttonState){
  returnElement("button.atc_btn .atc_button_inner > span").innerText = buttonText;
  buttonState ? returnElement("button.atc_btn").classList.add("disabled") : returnElement("button.atc_btn").classList.remove("disabled");
}

/*****Variants changing Functionality****/
const variantInputs = returnElements(".variant_selector_box input[data-variant-input]");
if(variantInputs.length > 0){ 
  variantInputs.forEach(function(e){e.addEventListener("change",function(){getCurrentVariant();})})
}
getCurrentVariant();

/***Enable Rooster Product on load**/
function activateRooster(){
  const activeTabLink = returnElement("button.tablinks.active").getAttribute('data-id');
  // returnElement(".freeRooster.active")?.classList.remove('active');
  // returnElement(".freeRooster[data-id='"+activeTabLink+"']").classList.add("active"); 

  returnElement(".rooster_options:not([hidden])").setAttribute("hidden",true);
  returnElement(".rooster_options[data-id='"+activeTabLink+"']").removeAttribute("hidden");
}
activateRooster();

/***Trigger for image to show correct variant options***/   

const allImgtrigger = returnElements('[imgtrigger]');
if(allImgtrigger.length > 0){
  allImgtrigger.forEach(function(element){
    element.addEventListener("click",function(){
      const productId = this.getAttribute('data-id');
      this.closest('.tabcontent').querySelector(".tab_prod_container.tab_prod_container_active").classList.remove('tab_prod_container_active');
      this.classList.add('tab_prod_container_active');
      returnElement(".product_settings:not([hidden])").setAttribute("hidden",true);
      returnElement(".product_settings[data-product-id='"+productId+"']").removeAttribute("hidden");
      
      /**Activate Button and Selling Plan**/
      getCurrentVariant();
    })
  })
}

/*****Selling Plan Trigger Fiunctionality****/
const sellingPlans = returnElements('.package_container');
if(sellingPlans.length > 0){
  sellingPlans.forEach(function(element){
    element.addEventListener("click",function(){
      const currentIndex = Number(this.getAttribute('data-index'));
      const allProducts = returnElements('.product-setting-box');
      allProducts.forEach(function(e){
        const planInput = e.querySelector('.sellingPlan').value.split(',');
        const currentPlan = planInput[currentIndex];
        const variantInputs = e.querySelectorAll(".hidden-input");
        variantInputs.forEach(function(e){
          e.setAttribute('data-selling_plans',currentPlan);
        })
      })
      returnElement('.package_container.active').classList.remove("active");
      this.classList.add('active');

      getCurrentVariant();
    })
  })
}

/***Case Product Trigger****/
const caseTrigger = returnElements(".single_case");
if(caseTrigger.length > 0){
  caseTrigger.forEach(function(e){
    e.addEventListener("click",function(){
      this.closest(".case_selection").querySelector('.single_case.active')?.classList.remove('active');
      this.classList.add('active');
      this.closest(".case_selection").querySelector(".btn-box.active")?.classList.remove('active');
      this.closest(".casbox").querySelector(".btn-box").classList.add("active");
      getCurrentVariant();
    })
  })
}
/***Case Trigger ON and Off**/
/*const casetoggler = returnElements('[casetrigger]');
if(casetoggler.length > 0){
  casetoggler.forEach(function(e){
    e.addEventListener('click',function(){
      questionToggler(this,".case_selection_box",'[casetrigger].question_btn.active');
      getCurrentVariant();
    })
  })
}*/

/***ROOSTER OPTIONS TRIGGER***/
const freeRoosterOption_trigger = document.querySelectorAll(".freeRangeRoster_options input");
if(freeRoosterOption_trigger.length > 0){
  freeRoosterOption_trigger.forEach(function(e){
   e.addEventListener("change",function(){
    console.log("chnaged");
    getCurrentVariant();
  }) 
  })
}


/****ROOSTER OPTIONS TRIGGER END***/
/*function questionToggler(ele,returnEle,secondReturnEle){
  const value = ele.getAttribute('data-value');
  const elemn = returnElement(returnEle);
  if(value == 'no'){
    elemn.setAttribute("hidden",true);
  }else{
    elemn.removeAttribute("hidden");
  }
  returnElement(secondReturnEle).classList.remove('active');
  ele.classList.add('active');
}*/
/****Roster Trigger***/

/*const roostertoggler = returnElements('[rostertrigger]');
if(roostertoggler.length > 0){
  roostertoggler.forEach(function(e){
    e.addEventListener('click',function(){
      questionToggler(this,".Extra_rooster",'[rostertrigger].question_btn.active');
      getCurrentVariant();
    })
  })
}*/

/***Add to cart button***/
function findVariant(variantTitle = ""){
  const foundProduct = returnElements(".product_settings:not([hidden]) .variant-input-wrap");
  foundProduct.forEach(function(e,index){
    variantTitle = variantTitle + e.querySelector('input:checked').value.toLowerCase().replace(' ','-');
    if((index+1) < foundProduct.length){
      variantTitle = variantTitle + '-';
    }
  });
  return variantTitle;
}

function findVariantInput(variantTitle){
  const variantParent = returnElement('.product_settings:not([hidden])');
  return variantParent.querySelector("input.hidden-input[value*='"+variantTitle+"']");;
}

const addToCart = returnElement('button.atc_btn');
addToCart.addEventListener("click",function(){
  let variantTitle = findVariant();
  const variantInput = findVariantInput(variantTitle);
  const selling_plan = Number(variantInput.getAttribute("data-selling_plans")); 
  const variant_id = Number(variantInput.value.split('/').pop());

  /***Get Compartment Product***/
  const comProduct = returnElement(".case_selection_box:not([hidden]) .single_case.active");
  const wantComProduct = comProduct ? true : false;

  /****Get Rooster Product****/
  // const roosterOptions = returnElements(".rooster_options:not([hidden]) .rooster_selection");
  // let roosterValue = "";
  // if(roosterOptions.length > 0){
  //   roosterOptions.forEach(function(e,index){
  //      roosterValue = roosterValue + e.querySelector("input:checked")?.value.replace(' ','-').toLowerCase();
  //     if((index+1) < roosterOptions.length){
  //       roosterValue = roosterValue + '-';
  //     }
  //   })
  // }
  const roosterProduct = document.querySelector(".freeRooster.active .roster-input[value*='"+variantTitle+"']");
  const wantRooster = roosterProduct ? true : false;
  
  function roosterAjax(){
    if(wantRooster){
      const rooster_Id = Number(roosterProduct.value.split('/').pop());
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
        cache: false,
        async: false,
        quantity: 1,
        id: rooster_Id,
        },
        dataType: "json",
        success: function (data) {
          cartUpdate();
        },
      });
    }else{
      cartUpdate();
    }
  }

  function cartUpdate(){
    jQuery.getJSON('/cart.js', function(cart) {
      console.log(cart);
      sessionStorage.setItem("bundleToken", cart.token);
      location.href = "/checkout?discount=XXAA5VD73135,ZSAVJY3G4VHK";
      setTimeout(function(){
        returnElement("button.atc_btn").disabled = false;
      },3000)
    });
  }

  /****Main Ajax to send product in cart****/
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      cache: false,
      async: false,
      quantity: 1,
      id: variant_id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    beforeSend: function(){
      returnElement("button.atc_btn").disabled = true;
    },
    success: function (data) {

      /*********START: FREE GIFT SENDING CODING*******/
      const giftContainer = returnElement(".sec_1_right_item3 .gift_container .variantImage.active");
      if(giftContainer){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            cache: false,
            async: false,
            quantity: 1,
            id: Number(giftContainer.getAttribute("data-variant")),
          },
          dataType: "json",
          success: function (data) {
            compartmentSend();
          },
          error: function(){
            compartmentSend();
          },
        });
      }else{
        compartmentSend();
      }
      /*******END: FREE GIFT SENDING CODING******/
      function compartmentSend(){
        if(wantComProduct){
          const comProduct_id = Number(comProduct.getAttribute('data-variant'));
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              cache: false,
              async: false,
              quantity: 1,
              id: comProduct_id,
            },
            dataType: "json",
            success: function (data) {
              roosterAjax();
            },
          }); 
        }else{
          roosterAjax();
        }
      }
    },
    error: function(){
      returnElement("button.atc_btn").disabled = false;
    },
  });
});
$('.btn-box').click(function () {
  $(this).parents(".case_selection").find(".single_case.active").removeClass("active");
  $(this).parents(".case_selection").find(".btn-box.active").removeClass("active");
  $(this).parents('.casbox').find('.single_case').addClass('active');
  $(this).addClass('active');
})

$('.mobile-opacity .load-more-box a').click(function(){
    $(this).parents('.mobile-opacity').removeClass('mobile-opacity');
})
      function toggleActiveClass(boxId) {
            const box = document.getElementById(boxId);
            const button = box.querySelector("button");
            box.classList.toggle("active");

            if (box.classList.contains("active")) {
                button.textContent = "Added";
            } else {
                button.textContent = "Add " + "+";
            }
        }

        // Add click event listeners for the Men Box and Women Box
        document.getElementById("men_box").addEventListener("click", function () {
            toggleActiveClass("men_box");
            toggleActiveClass("men_rooster");
        });

        document.getElementById("women_box").addEventListener("click", function () {
            toggleActiveClass("women_box");
            toggleActiveClass("women_rooster");
        });



/* NEW VERSIONS  */

const packageContainers = document.querySelectorAll('.package_container');
const single_case_container =document.querySelectorAll('.single_case');
const variantImage_container = document.querySelectorAll('.variantImage');

function handleClassChange(mutationsList) {
    mutationsList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const packageContainer = mutation.target;
            const parentElement = packageContainer.parentElement;

            if (packageContainer.classList.contains('active')) {
                parentElement.classList.add('active_package');
            } else {
                parentElement.classList.remove('active_package');
            }
        }
    });
}

const observer = new MutationObserver(handleClassChange);

packageContainers.forEach((container) => {
    observer.observe(container, { attributes: true });
});
single_case_container.forEach((container) => {
    observer.observe(container, { attributes: true });
});
variantImage_container.forEach((container) => {
    observer.observe(container, { attributes: true });
});